import * as React from "react";

import { RecipesContext } from "..";

export function useRecipeSourceUrl(id) {
  const { host } = React.useContext(RecipesContext);

  return `${host}/recipes/src/${id}.json`;
}
